import { Button, Col, Row } from 'antd';
import React from 'react';
import ByMuvu from '../../PatientLandingGeneralComponents/ByMuvu';
import Question from './Question';

export default function SurveyContainer({ surveys }) {

  return (
    <Row className='patient-landing-container mt-30 mr-20 ml-20 mb-30  text-center' justify='center'>
      <Col span={24}>
        <h2 className='patient-landing-title'>{surveys.examName}</h2>
      </Col>
      <Col span={24}>
        <h3 className='patient-landing-subtitle text-orange'>{surveys.currentSurvey?.name}</h3>
      </Col>
      <Col span={24}>
        <h3 className='patient-landing-subtitle text-orange'>{surveys.currentIndex + 1} de {surveys.surveys?.length}</h3>
      </Col>
      {
        surveys.currentSurvey?.questions.map((question) => {
          return (
            <Col span={24} key={question.question_id} >
              <Question question={question} selectOption={surveys.selectOption} hasToScroll={question.question_id === surveys.questionFromSummary?.question_id} />
            </Col>
          )
        })
      }
      <Col span={24}>
        <Row className='text-center mt-30' justify='center'>
          <Col span={24} xxl={10} xl={10} md={12} className='text-center'>
            <Button className='cmt-button button-block-responsive' type="primary" size='large' block disabled={!surveys.checkIfAllQuestionsAnswered()} onClick={surveys.continueButton}>
              {
                surveys.questionFromSummary ? 'Confirmar respuestas' : surveys.currentIndex + 1 === surveys.surveys?.length ? 'Finalizar' : 'Siguiente'
              }
            </Button>
          </Col>
        </Row>
      </Col>
      <Col span={24} className='mt-30'>
        <ByMuvu />
      </Col>
    </Row>
  )
}
